import { Dispatch, SetStateAction, useState } from "react";
import SelectBox from "../common/SelectBox";
import styles from "./AddressField.module.css";

interface AddressFieldProps {
    AddressFieldMapData: string[][];
    selectedAddressIdx: number;
    setSelectedAddressIdx: Dispatch<SetStateAction<number>>;
}

/**
 * @author cjs
 * @date 2024-09-12 11:26:58
 * @remark 지도만들기 주소필드 사용자 설정 컴포넌트
 * @param props
 * @props PopupSettingProps
 *        AddressFieldData(required) : 지도 데이터
 * @returns AddressField
 */

function AddressField(props: AddressFieldProps) {
    const selectOption = (option: number) => {
        props.setSelectedAddressIdx(option);
    };

    return (
        <>
            <div className={styles.selectBox}>
                <SelectBox optionList={props.AddressFieldMapData[0]} selectOption={selectOption} selected={props.selectedAddressIdx} />
            </div>
            <ul className={styles.wrapAddress}>
                {props.AddressFieldMapData.map((data, idx) => {
                    if (idx <= 5) {
                        return (
                            <li key={idx} className={styles.address}>
                                {data[props.selectedAddressIdx]}
                            </li>
                        );
                    }
                })}
            </ul>
            <div className={styles.txtInfo}>
                위치 데이터 확인을 완료하였습니다
                <br />
                다른 컬럼을 사용하고 싶으시면 변경해주세요
                <br />
                <span className={styles.accentTxt}>(위치데이터는 초록색으로 표시됩니다)</span>
            </div>
        </>
    );
}

export default AddressField;
